import { KeyRound } from '@orgus/ui/icons';
import type { SettingsSection } from '../registry.ts';
import { SecretsView } from '../../policy/SecretsView.tsx';

const section: SettingsSection = {
  id: 'secrets',
  title: 'Secrets',
  description: 'Encrypted at rest, leased to sessions Orgus starts.',
  order: 20,
  group: 'security',
  keywords: ['secrets', 'env', 'environment variables', 'credentials', 'vault'],
  icon: KeyRound,
  Component: SecretsView,
  needs: { module: 'secrets', feature: 'Secrets', plural: true, instead: 'Until then, each machine runs its agents with the environment it already has.' },
};
export default section;
